var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TimeslotAuthLayout',[_c('TimeSlotSuccess',{attrs:{"message":'You have successfully created your account'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }